module.exports = __webpack_public_path__ + "static/media/an-awesome-wave.a2ea05e2.jpg";